import AxiosConfig from '../../../config/AxiosConfig';

const createOrUpdateQuote = async (ticketId, quotesData) => {
  try {
    const response = await AxiosConfig.create('put', `/quote/createOrUpdate`)
      .call({ ticketId, ...quotesData })
      .getResponseData();

    return response;
  } catch (err) {
    console.error('Failed to create or update quotes:', err);
    const errorMessage = `Création/mise à jour des devis échouée: ${err?.message}`;
    throw new Error(errorMessage);
  }
};

export default createOrUpdateQuote;
